import type { AxiosRequestParams } from "@/types/AxiosTypes";
import axios from "axios";
import { ApiMethod } from "@/types/Enums";

/**
 * Vue 전역 `$loading` 객체 가져오기
 */
// const getLoading = () => {
//   return window.$loading ?? null;
// };

/**
 * Axios 인터셉터 세팅
 */

/**
 * axios 요청 처리 공통 함수
 * @param method HTTP 메서드 (GET, POST, PUT, DELETE, PATCH) (기본값: GET)
 * @param url 요청할 API URL
 * @param params 파라미터 (GET 요청 시)
 * @param data 요청 본문 (POST, PUT 요청 시)
 * @param headers 추가적인 HTTP 헤더
 * @param responseType 응답 타입
 * @param useLoading 로딩 여부 (기본값 : true)
 * @returns Axios 응답 데이터
 */
export const apiRequest = async <T>({
  method = ApiMethod.GET,
  url,
  params,
  data,
  headers,
  responseType,
  useLoading = false,
  noAlert = false,
}: AxiosRequestParams): Promise<T> => {
  if (useLoading) window.$loading.show(); // 로딩 표시
  try {
    return await axios({
      method,
      url,
      params,
      data,
      withCredentials: true,
      headers: {
        ...headers,
        ...(noAlert && { noAlert: "true" }),
      },
      responseType,
    });
  } finally {
    if (useLoading) window.$loading.hide(); // 로딩 숨김
  }
};
